import { SectionCommentRowProps } from './SectionCommentRow';
import { SectionFeedbackTemplates, SectionLevelComments } from './utils';

export const sectionLevelComments: SectionLevelComments = {
  dates: [
    {
      commentId: 1,
      userId: 1,
      name: 'Hafiz Temuri',
      accountType: 'ti staff',
      email: 'htemuri@trueimpact.com',
      text: 'This is a section level comment in Overview.',
      createdAt: new Date('Sun Dec 01 2022').toDateString(),
    },
  ],
  description: [
    {
      commentId: 2,
      userId: 2,
      name: 'Kevin Cullen',
      accountType: 'donor',
      email: '',
      text: 'This is a section level comment in Date.',
      createdAt: new Date('Sun Dec 02 2022').toDateString(),
    },
  ],
};

export const feedbackTemplates: SectionFeedbackTemplates = {
  description: [
    {
      name: 'Name',
      questionId: 1,
      templates: [
        {
          name: 'Too Vague',
          createdAt: '07/14/2021',
          description: 'This description could be stronger.',
          userName: 'Sara Ansell',
        },
        {
          name: 'Too Vague 2',
          createdAt: '07/15/2021',
          description:
            'This description could be stronger by being more descriptive of the goals of the program and those who benefit.',
          userName: 'Sara Ansell',
        },
      ],
    },
  ],
  dates: [
    {
      name: 'Term',
      questionId: 21,
      templates: [
        {
          name: 'Not a fit',
          createdAt: '07/15/2021',
          description: 'This description doesn\'t fit the program.',
          userName: 'Kevin Cullen',
        },
        {
          name: 'More explanation',
          createdAt: '07/15/2022',
          description: 'This description needs more explanation.',
          userName: 'Sadie Miller',
        },
      ],
    },
  ],
};
